export const lightColorTokenGotoResolve = {
    'avatar-color-00': 'rgba(0, 158, 186, 1)',
    'avatar-color-01': 'rgba(0, 127, 163, 1)',
    'avatar-color-02': 'rgba(15, 89, 128, 1)',
    'avatar-color-10': 'rgba(36, 168, 89, 1)',
    'avatar-color-11': 'rgba(36, 138, 112, 1)',
    'avatar-color-12': 'rgba(24, 99, 73, 1)',
    'avatar-color-20': 'rgba(158, 150, 0, 1)',
    'avatar-color-21': 'rgba(137, 143, 55, 1)',
    'avatar-color-22': 'rgba(96, 100, 8, 1)',
    'avatar-color-30': 'rgba(196, 136, 0, 1)',
    'avatar-color-31': 'rgba(148, 116, 86, 1)',
    'avatar-color-32': 'rgba(153, 77, 3, 1)',
    'avatar-color-40': 'rgba(212, 101, 85, 1)',
    'avatar-color-41': 'rgba(163, 88, 109, 1)',
    'avatar-color-42': 'rgba(150, 42, 67, 1)',
    'avatar-color-50': 'rgba(178, 57, 159, 1)',
    'avatar-color-51': 'rgba(129, 104, 168, 1)',
    'avatar-color-52': 'rgba(108, 54, 153, 1)',
    'avatar-color-primary': 'rgba(42, 50, 56, 0.5)',
    'avatar-color-secondary': 'rgba(42, 50, 56, 0.1)',
    'background-color-default': 'rgba(255, 255, 255, 1)',
    'background-color-secondary': 'rgba(242, 246, 247, 1)',
    'badge-color-assist': 'rgba(41, 150, 157, 1)',
    'badge-color-audio': 'rgba(165, 148, 30, 1)',
    'badge-color-custom': 'rgba(0, 0, 0, 1)',
    'badge-color-customer': 'rgba(253, 76, 111, 1)',
    'badge-color-disabled': 'rgba(0, 0, 0, 0.3)',
    'badge-color-files': 'rgba(70, 91, 107, 0.7)',
    'badge-color-gotoresolve': 'rgba(125, 51, 255, 1)',
    'badge-color-meeting': 'rgba(246, 141, 46, 1)',
    'badge-color-message': 'rgba(64, 144, 255, 1)',
    'badge-color-training': 'rgba(153, 41, 119, 1)',
    'badge-color-voice': 'rgba(0, 170, 110, 1)',
    'badge-color-webinar': 'rgba(0, 192, 243, 1)',
    'blue-100': 'rgba(203, 243, 254, 1)',
    'blue-200': 'rgba(152, 215, 252, 1)',
    'blue-300': 'rgba(100, 187, 250, 1)',
    'blue-400': 'rgba(71, 145, 255, 1)',
    'blue-500': 'rgba(44, 114, 222, 1)',
    'blue-600': 'rgba(29, 82, 186, 1)',
    'blue-700': 'rgba(15, 53, 153, 1)',
    'border-color-brand': 'rgba(133, 82, 246, 1)',
    'border-color-danger': 'rgba(211, 58, 97, 1)',
    'border-color-default': 'rgba(88, 121, 143, 0.5)',
    'border-color-inverted': 'rgba(152, 182, 201, 0.5)',
    'border-color-persistent': 'rgba(88, 121, 143, 0.5)',
    'border-color-secondary': 'rgba(242, 246, 247, 1)',
    'border-color-success': 'rgba(27, 135, 86, 1)',
    'border-color-warning': 'rgba(165, 148, 30, 1)',
    'brand-100': 'rgba(235, 222, 255, 1)',
    'brand-200': 'rgba(218, 196, 255, 1)',
    'brand-300': 'rgba(194, 164, 255, 1)',
    'brand-400': 'rgba(163, 123, 251, 1)',
    'brand-500': 'rgba(133, 82, 246, 1)',
    'brand-600': 'rgba(95, 54, 211, 1)',
    'brand-700': 'rgba(50, 28, 156, 1)',
    'focus-border-color-danger': 'rgba(255, 255, 255, 1)',
    'focus-border-color-default': 'rgba(255, 255, 255, 1)',
    'focus-border-color-persistent': 'rgba(0, 0, 0, 1)',
    'focus-border-color-success': 'rgba(255, 255, 255, 1)',
    'focus-color-highlight-danger': 'rgba(165, 34, 81, 1)',
    'focus-color-highlight-default': 'rgba(0, 0, 0, 1)',
    'focus-color-highlight-persistent': 'rgba(255, 255, 255, 1)',
    'focus-color-highlight-success': 'rgba(20, 100, 89, 1)',
    'gradient-color-skeleton': 'undefined',
    'green-100': 'rgba(209, 246, 207, 1)',
    'green-200': 'rgba(161, 232, 165, 1)',
    'green-300': 'rgba(83, 206, 115, 1)',
    'green-400': 'rgba(43, 169, 92, 1)',
    'green-500': 'rgba(27, 135, 86, 1)',
    'green-600': 'rgba(20, 100, 89, 1)',
    'green-700': 'rgba(0, 79, 73, 1)',
    'icon-color-brand-default': 'rgba(133, 82, 246, 1)',
    'icon-color-brand-persistent': 'rgba(194, 164, 255, 1)',
    'icon-color-danger': 'rgba(211, 58, 97, 1)',
    'icon-color-default': 'rgba(0, 0, 0, 1)',
    'icon-color-disabled': 'rgba(0, 0, 0, 0.3)',
    'icon-color-inverted': 'rgba(255, 255, 255, 1)',
    'icon-color-persistent': 'rgba(255, 255, 255, 1)',
    'icon-color-persistent-disabled': 'rgba(255, 255, 255, 0.3)',
    'icon-color-secondary': 'rgba(42, 50, 56, 0.7)',
    'icon-color-success': 'rgba(27, 135, 86, 1)',
    'icon-color-warning': 'rgba(165, 148, 30, 1)',
    'interactive-color-brand-default': 'rgba(133, 82, 246, 1)',
    'interactive-color-brand-hover': 'rgba(95, 54, 211, 1)',
    'interactive-color-brand-pressed': 'rgba(50, 28, 156, 1)',
    'interactive-color-danger-default': 'rgba(211, 58, 97, 1)',
    'interactive-color-danger-hover': 'rgba(165, 34, 81, 1)',
    'interactive-color-danger-pressed': 'rgba(128, 18, 72, 1)',
    'interactive-color-disabled': 'rgba(0, 0, 0, 0.1)',
    'interactive-color-neutral-default': 'rgba(242, 246, 247, 1)',
    'interactive-color-neutral-hover': 'rgba(217, 227, 233, 1)',
    'interactive-color-neutral-pressed': 'rgba(195, 212, 222, 1)',
    'interactive-color-persistent-default': 'rgba(0, 0, 0, 1)',
    'interactive-color-persistent-hover': 'rgba(42, 50, 56, 1)',
    'interactive-color-persistent-pressed': 'rgba(61, 72, 82, 1)',
    'interactive-color-primary-default': 'rgba(0, 0, 0, 1)',
    'interactive-color-primary-hover': 'rgba(42, 50, 56, 1)',
    'interactive-color-primary-pressed': 'rgba(61, 72, 82, 1)',
    'interactive-color-secondary-default': 'rgba(88, 121, 143, 1)',
    'interactive-color-secondary-hover': 'rgba(88, 121, 143, 0.1)',
    'interactive-color-secondary-pressed': 'rgba(88, 121, 143, 0.3)',
    'interactive-color-success-default': 'rgba(27, 135, 86, 1)',
    'interactive-color-success-hover': 'rgba(20, 100, 89, 1)',
    'interactive-color-success-pressed': 'rgba(0, 79, 73, 1)',
    'neutral-000': 'rgba(255, 255, 255, 1)',
    'neutral-050': 'rgba(242, 246, 247, 1)',
    'neutral-100': 'rgba(217, 227, 233, 1)',
    'neutral-200': 'rgba(195, 212, 222, 1)',
    'neutral-300': 'rgba(152, 182, 201, 1)',
    'neutral-400': 'rgba(115, 153, 175, 1)',
    'neutral-500': 'rgba(88, 121, 143, 1)',
    'neutral-600': 'rgba(70, 91, 107, 1)',
    'neutral-700': 'rgba(61, 72, 82, 1)',
    'neutral-800': 'rgba(42, 50, 56, 1)',
    'neutral-900': 'rgba(0, 0, 0, 1)',
    'orange-100': 'rgba(254, 237, 222, 1)',
    'orange-200': 'rgba(255, 196, 140, 1)',
    'orange-300': 'rgba(246, 141, 46, 1)',
    'orange-400': 'rgba(219, 120, 28, 1)',
    'orange-500': 'rgba(179, 95, 17, 1)',
    'orange-600': 'rgba(140, 68, 0, 1)',
    'orange-700': 'rgba(112, 60, 10, 1)',
    'purple-100': 'rgba(235, 222, 255, 1)',
    'purple-200': 'rgba(218, 196, 255, 1)',
    'purple-300': 'rgba(194, 164, 255, 1)',
    'purple-400': 'rgba(163, 123, 251, 1)',
    'purple-500': 'rgba(133, 82, 246, 1)',
    'purple-600': 'rgba(95, 54, 211, 1)',
    'purple-700': 'rgba(50, 28, 156, 1)',
    'red-100': 'rgba(254, 231, 226, 1)',
    'red-200': 'rgba(244, 195, 191, 1)',
    'red-300': 'rgba(230, 162, 162, 1)',
    'red-400': 'rgba(217, 111, 126, 1)',
    'red-500': 'rgba(211, 58, 97, 1)',
    'red-600': 'rgba(165, 34, 81, 1)',
    'red-700': 'rgba(128, 18, 72, 1)',
    'scrim-color': 'rgba(42, 50, 56, 0.7)',
    'surface-color-brand-default': 'rgba(133, 82, 246, 1)',
    'surface-color-brand-secondary': 'rgba(133, 82, 246, 0.1)',
    'surface-color-danger-default': 'rgba(211, 58, 97, 1)',
    'surface-color-danger-secondary': 'rgba(211, 58, 97, 0.1)',
    'surface-color-default': 'rgba(255, 255, 255, 1)',
    'surface-color-default-semitransparent': 'rgba(255, 255, 255, 0.7)',
    'surface-color-inverted': 'rgba(0, 0, 0, 1)',
    'surface-color-persistent': 'rgba(0, 0, 0, 1)',
    'surface-color-secondary': 'rgba(242, 246, 247, 1)',
    'surface-color-success-default': 'rgba(27, 135, 86, 1)',
    'surface-color-success-secondary': 'rgba(27, 135, 86, 0.1)',
    'surface-color-tertiary': 'rgba(88, 121, 143, 0.5)',
    'surface-color-utility-orange': 'rgba(246, 141, 46, 0.1)',
    'surface-color-utility-purple': 'rgba(194, 164, 255, 0.1)',
    'surface-color-warning-default': 'rgba(242, 221, 6, 1)',
    'surface-color-warning-secondary': 'rgba(242, 221, 6, 0.1)',
    'type-color-brand-default': 'rgba(133, 82, 246, 1)',
    'type-color-brand-persistent': 'rgba(194, 164, 255, 1)',
    'type-color-danger': 'rgba(211, 58, 97, 1)',
    'type-color-default': 'rgba(0, 0, 0, 1)',
    'type-color-disabled': 'rgba(0, 0, 0, 0.3)',
    'type-color-inverted': 'rgba(255, 255, 255, 1)',
    'type-color-persistent': 'rgba(255, 255, 255, 1)',
    'type-color-persistent-disabled': 'rgba(255, 255, 255, 0.3)',
    'type-color-secondary': 'rgba(42, 50, 56, 0.7)',
    'type-color-secondary-inverted': 'rgba(152, 182, 201, 0.7)',
    'type-color-success': 'rgba(27, 135, 86, 1)',
    'type-color-warning': 'rgba(165, 148, 30, 1)',
    'yellow-100': 'rgba(255, 253, 169, 1)',
    'yellow-200': 'rgba(255, 251, 123, 1)',
    'yellow-300': 'rgba(242, 221, 6, 1)',
    'yellow-400': 'rgba(214, 194, 18, 1)',
    'yellow-500': 'rgba(165, 148, 30, 1)',
    'yellow-600': 'rgba(134, 117, 28, 1)',
    'yellow-700': 'rgba(104, 87, 20, 1)',
};
export const lightBackgroundBlurGotoResolve = {
    'blur-large': '50px',
    'blur-medium': '30px',
    'blur-small': '10px',
    'blur-xlarge': '70px',
};
export const lightElevationGotoResolve = {
    'elevation-large': '0px 9px 12px rgba(0, 0, 0, 0.14), 0px 3px 16px rgba(0, 0, 0, 0.12), 0px 5px 6px rgba(0, 0, 0, 0.2), ',
    'elevation-medium': '0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2), ',
    'elevation-none': 'none',
    'elevation-small': '0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2), ',
    'elevation-xlarge': '0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2), ',
};
export const lightSpacingGotoResolve = {
    'layout-01': '16px',
    'layout-02': '24px',
    'layout-03': '32px',
    'layout-04': '48px',
    'layout-05': '64px',
    'layout-06': '96px',
    'layout-07': '160px',
    'spacing-01': '4px',
    'spacing-02': '8px',
    'spacing-03': '12px',
    'spacing-04': '16px',
    'spacing-05': '20px',
    'spacing-06': '24px',
    'spacing-07': '32px',
    'spacing-08': '40px',
    'spacing-09': '48px',
};
export const lightRadiusGotoResolve = {
    'radius-circle': '1000px',
    'radius-large': '12px',
    'radius-medium': '8px',
    'radius-none': '0px',
    'radius-small': '4px',
    'radius-xlarge': '16px',
};
export const darkColorTokenGotoResolve = {
    'avatar-color-00': 'rgba(190, 217, 254, 1)',
    'avatar-color-01': 'rgba(63, 192, 193, 1)',
    'avatar-color-02': 'rgba(31, 156, 182, 1)',
    'avatar-color-10': 'rgba(127, 254, 209, 1)',
    'avatar-color-11': 'rgba(112, 206, 95, 1)',
    'avatar-color-12': 'rgba(0, 169, 110, 1)',
    'avatar-color-20': 'rgba(254, 231, 139, 1)',
    'avatar-color-21': 'rgba(203, 184, 93, 1)',
    'avatar-color-22': 'rgba(216, 172, 0, 1)',
    'avatar-color-30': 'rgba(254, 189, 127, 1)',
    'avatar-color-31': 'rgba(239, 137, 83, 1)',
    'avatar-color-32': 'rgba(218, 120, 28, 1)',
    'avatar-color-40': 'rgba(249, 179, 193, 1)',
    'avatar-color-41': 'rgba(240, 134, 186, 1)',
    'avatar-color-42': 'rgba(252, 76, 111, 1)',
    'avatar-color-50': 'rgba(212, 190, 254, 1)',
    'avatar-color-51': 'rgba(191, 158, 255, 1)',
    'avatar-color-52': 'rgba(154, 102, 254, 1)',
    'avatar-color-primary': 'rgba(217, 227, 233, 0.5)',
    'avatar-color-secondary': 'rgba(217, 227, 233, 0.1)',
    'background-color-default': 'rgba(0, 0, 0, 1)',
    'background-color-secondary': 'rgba(42, 50, 56, 1)',
    'badge-color-assist': 'rgba(41, 150, 157, 1)',
    'badge-color-audio': 'rgba(242, 221, 6, 1)',
    'badge-color-custom': 'rgba(255, 255, 255, 1)',
    'badge-color-customer': 'rgba(253, 76, 111, 1)',
    'badge-color-disabled': 'rgba(255, 255, 255, 0.3)',
    'badge-color-files': 'rgba(152, 182, 201, 0.7)',
    'badge-color-gotoresolve': 'rgba(125, 51, 255, 1)',
    'badge-color-meeting': 'rgba(246, 141, 46, 1)',
    'badge-color-message': 'rgba(64, 144, 255, 1)',
    'badge-color-training': 'rgba(153, 41, 119, 1)',
    'badge-color-voice': 'rgba(0, 170, 110, 1)',
    'badge-color-webinar': 'rgba(0, 192, 243, 1)',
    'blue-100': 'rgba(203, 243, 254, 1)',
    'blue-200': 'rgba(152, 215, 252, 1)',
    'blue-300': 'rgba(100, 187, 250, 1)',
    'blue-400': 'rgba(71, 145, 255, 1)',
    'blue-500': 'rgba(44, 114, 222, 1)',
    'blue-600': 'rgba(29, 82, 186, 1)',
    'blue-700': 'rgba(15, 53, 153, 1)',
    'border-color-brand': 'rgba(235, 222, 255, 1)',
    'border-color-danger': 'rgba(211, 58, 97, 1)',
    'border-color-default': 'rgba(152, 182, 201, 0.5)',
    'border-color-inverted': 'rgba(88, 121, 143, 0.5)',
    'border-color-persistent': 'rgba(88, 121, 143, 0.5)',
    'border-color-secondary': 'rgba(42, 50, 56, 1)',
    'border-color-success': 'rgba(83, 206, 115, 1)',
    'border-color-warning': 'rgba(242, 221, 6, 1)',
    'brand-100': 'rgba(235, 222, 255, 1)',
    'brand-200': 'rgba(218, 196, 255, 1)',
    'brand-300': 'rgba(194, 164, 255, 1)',
    'brand-400': 'rgba(163, 123, 251, 1)',
    'brand-500': 'rgba(133, 82, 246, 1)',
    'brand-600': 'rgba(95, 54, 211, 1)',
    'brand-700': 'rgba(50, 28, 156, 1)',
    'focus-border-color-danger': 'rgba(0, 0, 0, 1)',
    'focus-border-color-default': 'rgba(0, 0, 0, 1)',
    'focus-border-color-persistent': 'rgba(0, 0, 0, 1)',
    'focus-border-color-success': 'rgba(0, 0, 0, 1)',
    'focus-color-highlight-danger': 'rgba(244, 195, 191, 1)',
    'focus-color-highlight-default': 'rgba(255, 255, 255, 1)',
    'focus-color-highlight-persistent': 'rgba(255, 255, 255, 1)',
    'focus-color-highlight-success': 'rgba(161, 232, 165, 1)',
    'gradient-color-skeleton': 'undefined',
    'green-100': 'rgba(209, 246, 207, 1)',
    'green-200': 'rgba(161, 232, 165, 1)',
    'green-300': 'rgba(83, 206, 115, 1)',
    'green-400': 'rgba(43, 169, 92, 1)',
    'green-500': 'rgba(27, 135, 86, 1)',
    'green-600': 'rgba(20, 100, 89, 1)',
    'green-700': 'rgba(0, 79, 73, 1)',
    'icon-color-brand-default': 'rgba(194, 164, 255, 1)',
    'icon-color-brand-persistent': 'rgba(194, 164, 255, 1)',
    'icon-color-danger': 'rgba(211, 58, 97, 1)',
    'icon-color-default': 'rgba(255, 255, 255, 1)',
    'icon-color-disabled': 'rgba(255, 255, 255, 0.3)',
    'icon-color-inverted': 'rgba(0, 0, 0, 1)',
    'icon-color-persistent': 'rgba(255, 255, 255, 1)',
    'icon-color-persistent-disabled': 'rgba(255, 255, 255, 0.3)',
    'icon-color-secondary': 'rgba(217, 227, 233, 0.7)',
    'icon-color-success': 'rgba(83, 206, 115, 1)',
    'icon-color-warning': 'rgba(242, 221, 6, 1)',
    'interactive-color-brand-default': 'rgba(194, 164, 255, 1)',
    'interactive-color-brand-hover': 'rgba(218, 196, 255, 1)',
    'interactive-color-brand-pressed': 'rgba(235, 222, 255, 1)',
    'interactive-color-danger-default': 'rgba(211, 58, 97, 1)',
    'interactive-color-danger-hover': 'rgba(217, 111, 126, 1)',
    'interactive-color-danger-pressed': 'rgba(230, 162, 162, 1)',
    'interactive-color-disabled': 'rgba(255, 255, 255, 0.1)',
    'interactive-color-neutral-default': 'rgba(42, 50, 56, 1)',
    'interactive-color-neutral-hover': 'rgba(61, 72, 82, 1)',
    'interactive-color-neutral-pressed': 'rgba(70, 91, 107, 1)',
    'interactive-color-persistent-default': 'rgba(0, 0, 0, 1)',
    'interactive-color-persistent-hover': 'rgba(42, 50, 56, 1)',
    'interactive-color-persistent-pressed': 'rgba(61, 72, 82, 1)',
    'interactive-color-primary-default': 'rgba(255, 255, 255, 1)',
    'interactive-color-primary-hover': 'rgba(242, 246, 247, 1)',
    'interactive-color-primary-pressed': 'rgba(217, 227, 233, 1)',
    'interactive-color-secondary-default': 'rgba(152, 182, 201, 1)',
    'interactive-color-secondary-hover': 'rgba(152, 182, 201, 0.1)',
    'interactive-color-secondary-pressed': 'rgba(152, 182, 201, 0.3)',
    'interactive-color-success-default': 'rgba(83, 206, 115, 1)',
    'interactive-color-success-hover': 'rgba(161, 232, 165, 1)',
    'interactive-color-success-pressed': 'rgba(209, 246, 207, 1)',
    'neutral-000': 'rgba(255, 255, 255, 1)',
    'neutral-050': 'rgba(242, 246, 247, 1)',
    'neutral-100': 'rgba(217, 227, 233, 1)',
    'neutral-200': 'rgba(195, 212, 222, 1)',
    'neutral-300': 'rgba(152, 182, 201, 1)',
    'neutral-400': 'rgba(115, 153, 175, 1)',
    'neutral-500': 'rgba(88, 121, 143, 1)',
    'neutral-600': 'rgba(70, 91, 107, 1)',
    'neutral-700': 'rgba(61, 72, 82, 1)',
    'neutral-800': 'rgba(42, 50, 56, 1)',
    'neutral-900': 'rgba(0, 0, 0, 1)',
    'orange-100': 'rgba(254, 237, 222, 1)',
    'orange-200': 'rgba(255, 196, 140, 1)',
    'orange-300': 'rgba(246, 141, 46, 1)',
    'orange-400': 'rgba(219, 120, 28, 1)',
    'orange-500': 'rgba(179, 95, 17, 1)',
    'orange-600': 'rgba(140, 68, 0, 1)',
    'orange-700': 'rgba(112, 60, 10, 1)',
    'purple-100': 'rgba(235, 222, 255, 1)',
    'purple-200': 'rgba(218, 196, 255, 1)',
    'purple-300': 'rgba(194, 164, 255, 1)',
    'purple-400': 'rgba(163, 123, 251, 1)',
    'purple-500': 'rgba(133, 82, 246, 1)',
    'purple-600': 'rgba(95, 54, 211, 1)',
    'purple-700': 'rgba(50, 28, 156, 1)',
    'red-100': 'rgba(254, 231, 226, 1)',
    'red-200': 'rgba(244, 195, 191, 1)',
    'red-300': 'rgba(230, 162, 162, 1)',
    'red-400': 'rgba(217, 111, 126, 1)',
    'red-500': 'rgba(211, 58, 97, 1)',
    'red-600': 'rgba(165, 34, 81, 1)',
    'red-700': 'rgba(128, 18, 72, 1)',
    'scrim-color': 'rgba(42, 50, 56, 0.7)',
    'surface-color-brand-default': 'rgba(194, 164, 255, 1)',
    'surface-color-brand-secondary': 'rgba(194, 164, 255, 0.1)',
    'surface-color-danger-default': 'rgba(211, 58, 97, 1)',
    'surface-color-danger-secondary': 'rgba(211, 58, 97, 0.1)',
    'surface-color-default': 'rgba(0, 0, 0, 1)',
    'surface-color-default-semitransparent': 'rgba(0, 0, 0, 0.7)',
    'surface-color-inverted': 'rgba(255, 255, 255, 1)',
    'surface-color-persistent': 'rgba(0, 0, 0, 1)',
    'surface-color-secondary': 'rgba(42, 50, 56, 1)',
    'surface-color-success-default': 'rgba(83, 206, 115, 1)',
    'surface-color-success-secondary': 'rgba(83, 206, 115, 0.1)',
    'surface-color-tertiary': 'rgba(152, 182, 201, 0.5)',
    'surface-color-utility-orange': 'rgba(246, 141, 46, 0.1)',
    'surface-color-utility-purple': 'rgba(194, 164, 255, 0.1)',
    'surface-color-warning-default': 'rgba(242, 221, 6, 1)',
    'surface-color-warning-secondary': 'rgba(242, 221, 6, 0.1)',
    'type-color-brand-default': 'rgba(194, 164, 255, 1)',
    'type-color-brand-persistent': 'rgba(194, 164, 255, 1)',
    'type-color-danger': 'rgba(230, 162, 162, 1)',
    'type-color-default': 'rgba(255, 255, 255, 1)',
    'type-color-disabled': 'rgba(255, 255, 255, 0.3)',
    'type-color-inverted': 'rgba(0, 0, 0, 1)',
    'type-color-persistent': 'rgba(255, 255, 255, 1)',
    'type-color-persistent-disabled': 'rgba(255, 255, 255, 0.3)',
    'type-color-secondary': 'rgba(217, 227, 233, 0.7)',
    'type-color-secondary-inverted': 'rgba(70, 91, 107, 0.7)',
    'type-color-success': 'rgba(83, 206, 115, 1)',
    'type-color-warning': 'rgba(242, 221, 6, 1)',
    'yellow-100': 'rgba(255, 253, 169, 1)',
    'yellow-200': 'rgba(255, 251, 123, 1)',
    'yellow-300': 'rgba(242, 221, 6, 1)',
    'yellow-400': 'rgba(214, 194, 18, 1)',
    'yellow-500': 'rgba(165, 148, 30, 1)',
    'yellow-600': 'rgba(134, 117, 28, 1)',
    'yellow-700': 'rgba(104, 87, 20, 1)',
};
export const darkBackgroundBlurGotoResolve = {
    'blur-large': '50px',
    'blur-medium': '30px',
    'blur-small': '10px',
    'blur-xlarge': '70px',
};
export const darkElevationGotoResolve = {
    'elevation-large': '0px 9px 12px rgba(0, 0, 0, 0.14), 0px 3px 16px rgba(0, 0, 0, 0.12), 0px 5px 6px rgba(0, 0, 0, 0.2), ',
    'elevation-medium': '0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2), ',
    'elevation-none': 'none',
    'elevation-small': '0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2), ',
    'elevation-xlarge': '0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2), ',
};
export const darkSpacingGotoResolve = {
    'layout-01': '16px',
    'layout-02': '24px',
    'layout-03': '32px',
    'layout-04': '48px',
    'layout-05': '64px',
    'layout-06': '96px',
    'layout-07': '160px',
    'spacing-01': '4px',
    'spacing-02': '8px',
    'spacing-03': '12px',
    'spacing-04': '16px',
    'spacing-05': '20px',
    'spacing-06': '24px',
    'spacing-07': '32px',
    'spacing-08': '40px',
    'spacing-09': '48px',
};
export const darkRadiusGotoResolve = {
    'radius-circle': '1000px',
    'radius-large': '12px',
    'radius-medium': '8px',
    'radius-none': '0px',
    'radius-small': '4px',
    'radius-xlarge': '16px',
};
